import React from 'react';
import styled, { css } from 'styled-components';
import { Spacing4, Spacing16 } from 'autogen/design-tokens/tokens';
import type { SessionMenuViewModel } from 'autogen/swagger/all';
import SessionMenuItem from 'components/SessionMenu/components/Items';
import { breakpoint, sizes } from 'variables';

/* #region  styles */
const MenuContainer = styled.nav`
    display: grid;
    grid-template-columns: repeat(auto-fit, 40px);
    min-height: 32px;
    justify-content: flex-end;
    grid-auto-flow: column;
    width: 100%;
    gap: ${Spacing4};

    ${breakpoint.up(361)} {
        grid-template-columns: repeat(auto-fit, minmax(32px, 40px));
        gap: ${Spacing16};
    }

    ${breakpoint.up(sizes.lg)} {
        grid-template-columns: repeat(auto-fit, minmax(32px, 56px));
    }
`;

const HideOnMobile = css`
    display: none;

    ${breakpoint.up(sizes.sm)} {
        display: flex;
    }
`;
/* #endregion */

export default function KickIpadSessionMenu({
    model: { findStoreUrl, basketLinkAction }
}: {
    model: SessionMenuViewModel;
}) {
    return (
        <MenuContainer>
            {findStoreUrl && <SessionMenuItem.FindStore linkAction={findStoreUrl} css={HideOnMobile} />}
            <SessionMenuItem.Basket linkAction={basketLinkAction} />
        </MenuContainer>
    );
}
